import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useAuth, formatApiError } from "@/lib/auth";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back.");
      navigate(location.state?.from || "/me", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e, "Incorrect email or password."));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main className="max-w-md mx-auto px-6 pt-12 md:pt-20 pb-24" data-testid="login-page">
        <span className="label-overline">Welcome back</span>
        <h1 className="font-serif text-5xl text-oxblood mt-3">Sign in.</h1>
        <form onSubmit={submit} className="mt-10 space-y-8" data-testid="login-form">
          <div>
            <label className="label-overline flex items-center gap-2"><Mail size={12} /> Email</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-flat mt-2" data-testid="login-email" />
          </div>
          <div>
            <label className="label-overline flex items-center gap-2"><Lock size={12} /> Password</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-flat mt-2" data-testid="login-password" />
          </div>
          <button type="submit" disabled={submitting} className="btn-primary w-full justify-center" data-testid="login-submit">
            {submitting ? "Signing you in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-8 text-sm text-inkSoft">
          No account yet? <Link to="/signup" className="text-cognac link-underline" data-testid="login-to-signup">Create your profile</Link>
        </p>
      </main>
      <Footer />
    </div>
  );
}
